import { Facebook, Instagram, LinkedIn, MailOutline, Phone, Room, Twitter } from '@mui/icons-material'
import React from 'react'
import styled from "styled-components"
import {mobile} from "../responses"
import { Link } from 'react-router-dom'
const Container=styled.div`
display:flex;
${mobile({flexDirection:"column",textAlign:"center"})};
`
const Left=styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    flex:1;
`

const Logo=styled.h1``
const Description=styled.p`
    margin: 20px 0px;
    `
const SocialContainer=styled.div`
    display: flex;
    ${mobile({justifyContent:"center"})};

`
const SocialIcon=styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: white;
    background-color: #${props=>props.color};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
    cursor: pointer;
    `
    
    
    
    const Center=styled.div`
        flex:1;
        padding: 20px;

    `
    const Title=styled.h3`
        margin-bottom: 20px;
        ${mobile({textAlign:"center"})};
    `
    const List=styled.ul`
        margin: 0;
    ${mobile({textAlign:"start"})};
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        padding: 0;

    `
    const ListItem=styled.li`
        width: 50%;
        margin-bottom: 10px;
    `

    
    const Right=styled.div`
        flex:1;
        padding: 20px;
    ${mobile({textAlign:"start",backgroundColor:"#f1ecec"})};
    `
    const Contactitem=styled.div`
        display: flex;
        margin-block: 10px;
        align-items: center;
    `
    const Payment=styled.img`
        width: 50%;

    `
const Footer = () => {
    const styleLogo={marginRight:"10px"};
  return (
    <Container>
        <Left>
            <Logo>
                Vivegam
            </Logo>
            <Description>
            Explore limitless possibilities with Vivegam, your premier destination for online shopping. Discover an array of high-quality products that cater to your every need. Experience seamless browsing, secure transactions, and exceptional customer service. Elevate your online shopping journey with Vivegam today.
            </Description>
            <SocialContainer>
                    <Link to={"https://www.facebook.com/vivekanand.ojha.716/"}>
                <SocialIcon color='3B5999'>
                    <Facebook></Facebook>
                </SocialIcon>


                    </Link>
                    <Link to={"https://www.instagram.com/viveknm_1331/"}>
                    <SocialIcon color='E4405F'>
                    <Instagram></Instagram>
                </SocialIcon>
                    </Link>


                    <Link to={"https://twitter.com/VivekN_Ojha"}>
                    <SocialIcon color='55ACEE'>
                    <Twitter></Twitter>
                </SocialIcon>
                    </Link>


                    <Link to={"https://www.linkedin.com/in/vivekanand-ojha-337797217/"}>
                    <SocialIcon color='E60023'>
                    <LinkedIn></LinkedIn>
                </SocialIcon>
                    </Link>

                

                

                

            </SocialContainer>
        </Left>


        <Center>

                <Title>
                    Useful Links
                </Title>
                <List>
                    <ListItem>Home</ListItem>
                    <ListItem>Cart</ListItem>
                    <ListItem>Man fashion</ListItem>
                    <ListItem>Women fashion</ListItem>
                    <ListItem>Accessories</ListItem>
                    <ListItem>My Account</ListItem>
                    <ListItem>Order tracking</ListItem>
                    <ListItem>Wishlist</ListItem>
                    <ListItem>Terms</ListItem>
                </List>

        </Center>



        <Right>
            <Title>
                Contact
            </Title>
            <Contactitem>
                <Room style={styleLogo}/>
                Hostel-J, NIT JAMSHEDPUR, JK
            </Contactitem>
            <Contactitem>
                <Phone style={styleLogo}/>
                +91 9118372331
            </Contactitem>
            <Contactitem>
                <MailOutline style={styleLogo}/>
                goluojha13101992@gmail.com
            </Contactitem>

            <Payment src={'https://i.ibb.co/Qfvn4z6/payment.png'}/>
        </Right>
      
    </Container>
  )
}

export default Footer
